// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Sn3w","name":"Header_name__267hV","aggregates":"Header_aggregates__3MRWK"};